<template>
  <div class="route-detail">
    <div class="route-detail-table">
      <vxe-toolbar size="mini" v-if="!disabled">
        <template v-slot:buttons>
          <el-button @click="newRowHandler" size="small" type="primary" class="vxe-btn-primary"
            >新建线路</el-button
          >
          <el-button @click="editRowHandler" size="small" type="primary" class="vxe-btn-primary"
            >编辑线路</el-button
          >
          <el-button @click="importHandler" size="small" type="primary" class="vxe-btn-primary"
            >导入</el-button
          >
          <el-button @click="deleteRowHandler" size="small" type="danger" class="vxe-btn-delete"
            >删除</el-button
          >
        </template>
      </vxe-toolbar>
      <vxe-toolbar size="mini" v-else>
        <template v-slot:buttons>
          <el-button @click="exportExcel" size="small" type="primary" class="vxe-btn-primary"
            >导出</el-button
          >
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="routeDetailRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :data="tableData"
        :valid-config="{ autoPos: true, message: 'inline' }"
        height="300"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in chartColumns"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :edit-render="item.editRender"
          :visible="item.visible"
        >
          <template v-slot="{ row }">
            <span v-if="item?.field == 'destinationType' || item?.field == 'departurePlaceType'">{{
              getPlaceName(row[item.field])
            }}</span>
            <span v-else>{{ row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
    <EditRouteDialog ref="dialogRef" @confirmHandler="confirmHandler"></EditRouteDialog>
    <SiruiUpload
      ref="siruiUpload"
      :isShowDownTemplateBtn="true"
      @ossSuccess="importSuccess"
      :action="IMPORT_URL"
      source="intermodality"
      :data="importData"
    />
  </div>
</template>

<script>
  import { chartColumns } from './columns.js';
  import EditRouteDialog from './editRouteDialog.vue';
  import SiruiUpload from '@/components/SiruiUpload';
  import API from '@/api/intermodality/contract.js';

  // import BASEAPI from '@/api/dataBase.js';
  export default {
    name: 'RouteDetailChart',
    components: {
      EditRouteDialog,
      SiruiUpload,
    },
    props: {
      tableDataList: {
        type: Array,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: () => false,
      },
      // baseFormData: {
      //   type: Object,
      //   require: true,
      // },
      contractCode: {
        type: String,
        default: () => '',
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectionList: [],
        tableData: [],
        currencyList: [],
        // tableRules,
        chartColumns,
        placeTypeList: [],
        IMPORT_URL: '/sales/mto/contract/importRount',
      };
    },
    methods: {
      async exportExcel() {
        if (!this.selectionList.length) {
          return this.$message.error('请先选择数据再导出');
        }
        let ids = this.selectionList.map((item) => item.tempId);
        const params = {
          ids,
          contractCode: this.contractCode,
        };
        let { data } = await this.$axios.post(API.EXPORT_ROUTES, params);
        if (data.code == 0) {
          window.location.href = data.data;
          this.$message.success('操作成功');
        } else {
          this.$message.error(data.msg);
        }
      },
      clearSelection() {
        this.$refs.routeDetailRef.clearCheckboxRow();
        this.selectionList = [];
      },
      getDicts() {
        //fixme 字典替换
        this.placeTypeList = [
          { label: '站', value: '0' },
          { label: '堆场', value: '1' },
          { label: '门', value: '2' },
          { label: '码头', value: '3' },
          { label: '港口', value: '4' },
        ];
      },
      getPlaceName(value) {
        let res = '';
        let item = this.placeTypeList.find((item) => item.value == value);
        if (item) {
          res = item.label;
        }
        return res;
      },
      // 新增行
      async newRowHandler() {
        this.clearSelection();
        this.$refs.dialogRef.openModal();
      },
      importHandler() {
        this.$refs.siruiUpload.openDialog(true, '099');
      },
      async importSuccess(response) {
        if (response.msg && response.msg.includes('导入失败')) {
          window.open(response.data);
          return;
        }
        let list = response.data;
        await this.$refs.routeDetailRef.insertAt(list, -1);
        this.tableData = this.getTableData();
        this.$emit('handleChartChange', 'route', this.tableData);
      },
      async insertEvent(rowData = {}, index = 0) {
        console.log(rowData, index);
        const $table = this.$refs.routeDetailRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (!errMap) {
          const { row: newRow } = await $table.insertAt(rowData, index);
          await $table.validate(newRow).catch((errMap) => errMap);
        }
      },
      async confirmHandler(data, isEdit) {
        if (isEdit) {
          const list = this.$refs.routeDetailRef?.getTableData()?.fullData;
          const index = list.findIndex((item) => item._XID == data.xid);
          delete data.xid;
          list.splice(index, 1, data);
          this.tableData = list;
        } else {
          await this.insertEvent(data, 0);
          this.tableData = this.getTableData();
        }

        this.$emit('handleChartChange', 'route', this.tableData);
      },
      editRowHandler() {
        if (this.selectionList.length && this.selectionList.length == 1) {
          let item = { ...this.selectionList[0] };
          this.$refs.dialogRef.openModal(item);
          this.clearSelection();
        } else {
          this.$message.error('请勾选一条数据进行编辑');
        }
      },
      deleteRowHandler() {
        // if (!this.selectionList.length || this.selectionList.length != 1) {
        //   this.$message.error('请勾选一条数据进行删除');
        //   return;
        // }
        if (this.selectionList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('billDetail.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction('删除数据', '是否删除所选数据？')
          .then(() => {
            this.$refs.routeDetailRef.removeSelecteds();
            this.tableData = this.getTableData();
            this.$emit('handleChartChange', 'route', this.tableData);
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('billDetail.message.deleteSuccess'),
            });
          })
          .catch((e) => {
            console.log(e);
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('billDetail.message.cancelled'),
            });
          });
      },
      handleSelectionChange({ selection }) {
        console.log(selection, '选择行');
        this.selectionList = selection;
      },
      handleChange(row, field) {
        console.log(row, field, '行');
        // if (field === 'currencyCode') {
        //   row['currencyName'] = this.currencyList?.find(
        //     (item) => item.value == row['currencyCode']
        //   )?.label;
        // } else if (field === 'expenseType') {
        //   row['expenseTypeLabel'] = this.expenseType?.find(
        //     (item) => item.value == row[field]
        //   )?.label;
        // } else if (field === 'originalAmount') {
        //   row['domesticAmount'] = (row['originalAmount'] * row['exchangeRate']).toFixed(2);
        // }
      },
      async closeEditTableHandler() {
        console.log('关闭');
        // const $table = this.$refs.settleAccountsRef;
        // const errMap = await $table.validate().catch((errMap) => errMap);
        // if (errMap) {
        //   this.$message.error('请检查数据再提交');
        // } else {
        //   // 派发事件
        //   this.$emit('closeEditTableHandler', this.getTableData());
        //   await $table.clearActived();
        // }
      },
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.routeDetailRef;
        return $table.getTableData().fullData;
      },
      // 反填数据
      fullTableData(val) {
        if (val && val.length) {
          this.tableData = val;
        } else {
          this.tableData = [];
        }
      },
    },
    computed: {
      // expenseType() {
      //   return this.dictListMap.expenseType;
      // },
      //导入额外参数
      importData() {
        return {
          tenantCode: this.userInfo.tenantCode,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          belongTenantCode: this.userInfo.tenantCode,
          dataGroup: this.$globalVar.dataGroup,
          access_token: this.userInfo.access_token,
        };
      },
    },
    watch: {
      tableDataList: {
        handler(val) {
          console.log(val, '子组件');
          this.fullTableData(val);
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {
      this.getDicts();
    },
  };
</script>

<style lang="scss" scoped>
  .route-detail {
    background: #fff;

    .route-detail-table {
      padding: 10px;
      box-sizing: border-box;
    }
  }
</style>
